<style lang="less">
    @import '../styles/public/public.less';
</style>
<template>
    <div>
    </div>
</template>

<script>
    export default {
        components: {
        },
        data() {
          return {
              
          };
        },
        methods: {
        },
        mounted() {
        },
        directives:{
        },
    };
</script>




// WEBPACK FOOTER //
// route.vue?32e51c9e